import React from 'react';
import { ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { alreadyGo, productName } from '../data/content';
import { CtaButton } from './CtaButton';
import { LeafSprig } from './decor/LeafSprig';
const mechanism = ['Ausdrucken.', 'Ausschneiden.', 'Weitergeben.', 'Samen säen.'];
export function FinalClose() {
  return <section aria-labelledby="close-title" className="bg-paper" data-id="element-69" data-mp="i69bfw6kgc1q">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-70" data-mp="1ft9g5o7bpvn9">
        <div className="grid gap-14 lg:grid-cols-[1fr_460px] lg:items-center lg:gap-16" data-id="element-71" data-mp="1fuklvtkbxdh0">
          <div data-id="element-72" data-mp="1avpzkhn5l6s5">
            <h2 id="close-title" className="text-balance font-display text-[40px] leading-[1.04] text-navy sm:text-[54px]" data-id="element-73" data-mp="162wwdy7c26i6">
              Wie viele Samen wirst du diese Woche säen?
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-74" data-mp="1yj7n20zdxipb">
              Diese Woche kann genauso vergehen wie die letzte. <strong className="text-navy" data-id="element-75" data-mp="1trzfzblj29fb">Oder sie wird die Woche, in der du anfängst.</strong>
            </p>
            <ul className="mt-6 grid gap-2 text-lg text-ink-soft sm:grid-cols-2" data-id="element-76" data-mp="nqdinwfcu4yo">
              {alreadyGo.map(a => <li key={a} data-id="element-77" data-mp="snvxg3g1zeel">{a}</li>)}
            </ul>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-78" data-mp="e0ar80nvsz2g">
              Die Gelegenheiten sind längst um dich herum. Jetzt kannst du über 200 Bibelverse auf mehr als 20 verschiedenen Designs griffbereit haben
              – vorbereitet für genau diese Momente.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-79" data-mp="90xwyuuokppu">
              Du musst nicht warten, bis deine Angst weg ist. Du musst nicht warten, bis du alles weißt.{' '}
              <strong className="text-navy" data-id="element-80" data-mp="3w4vwyfvw2gqq">Du musst nur bereit sein, den ersten Schritt zu gehen.</strong>
            </p>
            <ol className="mt-8 flex flex-wrap gap-x-4 gap-y-1" data-id="element-81" data-mp="1peekf4mnaj6g">
              {mechanism.map((m, i) => <li key={m} className={`font-display text-3xl sm:text-4xl ${i === mechanism.length - 1 ? 'italic text-leaf-deep' : 'text-navy'}`} data-id="element-82" data-mp="1ucpu9fcxwtoo" data-mpi={i}>
                  {m}
                </li>)}
            </ol>
          </div>

          <div className="relative rounded-3xl bg-cream p-8 text-center shadow-sheet ring-2 ring-coral/25 sm:p-10" data-id="element-83" data-mp="1nzlmk0ktqszs">
            <LeafSprig className="absolute -right-3 -top-8 h-20 w-10 rotate-12 text-leaf/60" data-id="element-84" data-mp="1dzcmgbnponf4" />
            <p className="font-display text-2xl leading-tight text-navy sm:text-[28px]" data-id="element-85" data-mp="1e1pexir3ig6f">
              Hol dir
              <span className="mt-1 block text-[20px] leading-tight sm:text-[24px]" data-id="element-86" data-mp="26o0gowqfun4t">{productName}</span>
            </p>
            <p className="mt-2 whitespace-nowrap font-display text-[88px] leading-none text-coral" aria-label="22,90 €" data-id="element-87" data-mp="21ws63xddgvq2">
              $19<span className="align-top text-[44px] leading-none" data-id="element-88" data-mp="1wxfivbil9mmy">,90</span>
            </p>
            <p className="mt-4 text-sm font-semibold leading-relaxed text-ink-soft" data-id="element-89" data-mp="2uemii69unb6d">
              Über 200 Bibelverse · 20+ druckfertige Designs · 5 Bonusmaterialien · Sofortiger digitaler Zugang · 7-Tage-Garantie
            </p>
            <CtaButton checkout block className="mt-6" data-id="element-90" data-mp="2xxle40obnf60">
              Jetzt das Paket sichern
            </CtaButton>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-semibold text-ink-soft" data-id="element-91" data-mp="31yx4i8f0s4f9">
              <span className="inline-flex items-center gap-1.5" data-id="element-92" data-mp="3bvjrb2qwp5jx">
                <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-93" data-mp="3bsxb6epy9hq3" />
                Sofortiger digitaler Zugang
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-94" data-mp="3kuwr13p8afrg">
                <ShieldCheckIcon className="h-4 w-4 text-leaf-deep" aria-hidden="true" data-id="element-95" data-mp="3pmyapaoq78ri" />
                7-Tage-Garantie
              </span>
            </div>
          </div>
        </div>
        <p className="mx-auto mt-16 max-w-2xl text-center font-display text-2xl italic leading-snug text-navy sm:text-3xl" data-id="element-96" data-mp="3fgigto25au0">
          Denn vielleicht braucht jemand, dem du diese Woche begegnest, genau die Botschaft, die du bei dir trägst.
        </p>
      </div>
    </section>;
}